<template>
    <v-container fluid class="text-xs-center"> 
        <v-text-field
            v-model="searchedText"
            placeholder="Cerca..."
          ></v-text-field>
        <div class="results-count">{{pets.length}} Risultati</div>
        <v-layout row wrap justify-center class="not-multiselecting">
            <v-flex xs12 md10>
                <span v-if="filteredPets.length==0">Nessun risultato</span>
                <v-card 
                    v-for="pet in filteredPets" :key="pet.id" 
                    @click="petClicked(pet)"
                >
                    <v-card-text>
                        <div class="inline-block" style="max-width: calc(100% - 70px);">
                            <strong>{{pet.name}}</strong><br>
                            {{pet.species}} {{pet.breed}}<br>
                            <div v-if="pet.microchip">Microchip: {{pet.microchip}}</div>
                            <div v-if="pet.birthday">Compleanno: {{pet.birthday|date}}</div>
                        </div>
                        <div class="card-chev"></div>
                    </v-card-text>
                </v-card>
                <v-btn v-show="pets.length>maxElements" @click="maxElements+=100" style="background:#209ecc;color:white;">
                    Mostra altri risultati...
                </v-btn>
            </v-flex>
        </v-layout>
        <v-btn
            color="green"
            dark
            absolute
            bottom
            right
            fab
            v-if="!multiselect"
            @click.native="$router.push({name: 'AllevamentoPetAdd'})"
            style="bottom:20px;font-size:40px;"
            > +
        </v-btn>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Allevamento',
    data: function(){
        return{
            searchedText: "",
            pets:[],
            maxElements: 100
        };
    },
    computed: {
        filteredPets(){
            let vm = this;
            if(vm.searchedText=='')
                return vm.pets.slice(0, vm.maxElements);
            return vm.pets.filter(function(el){
                return JSON.stringify(el).toUpperCase().includes(vm.searchedText.toUpperCase());
            }).slice(0, vm.maxElements);
        }
    },
    mounted: function(){
        let vm = this;
        vm.getPets();
    },
    methods:{
        petClicked(pet){
            let vm = this;
            vm.$router.push({name: 'pet', params:{petId:pet.id}});
        },
        getPets(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getPets.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.pets = [];
                    vm.pets = response.data.resources;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error);
                }
            });
        }
    }
}
</script>

